var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStatewallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 152,
    viewBox: "0 0 189 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6276 101.584H116.424C116.813 101.584 117.192 101.542 117.558 101.462C117.923 101.542 118.302 101.584 118.692 101.584H158.004C160.926 101.584 163.296 99.2148 163.296 96.2921C163.296 93.3694 160.926 91.0001 158.004 91.0001H153.468C150.545 91.0001 148.176 88.6308 148.176 85.7081C148.176 82.7854 150.545 80.4161 153.468 80.4161H167.832C170.754 80.4161 173.124 78.0468 173.124 75.1241C173.124 72.2014 170.754 69.8321 167.832 69.8321H151.2C154.122 69.8321 156.492 67.4628 156.492 64.5401C156.492 61.6174 154.122 59.2481 151.2 59.2481H102.816C105.738 59.2481 108.108 56.8788 108.108 53.9561C108.108 51.0334 105.738 48.6641 102.816 48.6641H59.7236C56.8009 48.6641 54.4316 51.0334 54.4316 53.9561C54.4316 56.8788 56.8009 59.2481 59.7236 59.2481H29.4836C26.5609 59.2481 24.1916 61.6174 24.1916 64.5401C24.1916 67.4628 26.5609 69.8321 29.4836 69.8321H48.3836C51.3062 69.8321 53.6756 72.2014 53.6756 75.1241C53.6756 78.0468 51.3062 80.4161 48.3836 80.4161H18.1436C15.2209 80.4161 12.8516 82.7854 12.8516 85.7081C12.8516 88.6308 15.2209 91.0001 18.1436 91.0001H47.6276C44.7049 91.0001 42.3356 93.3694 42.3356 96.2921C42.3356 99.2148 44.7049 101.584 47.6276 101.584ZM170.856 101.584C173.778 101.584 176.148 99.2148 176.148 96.2921C176.148 93.3694 173.778 91.0001 170.856 91.0001C167.933 91.0001 165.564 93.3694 165.564 96.2921C165.564 99.2148 167.933 101.584 170.856 101.584Z",
    fill: "#ECEFF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6667 42.6328H120.417C121.19 42.6328 121.932 42.9401 122.479 43.4871C123.026 44.0341 123.333 44.7759 123.333 45.5495V60.1328C123.333 60.9064 123.026 61.6482 122.479 62.1952C121.932 62.7422 121.19 63.0495 120.417 63.0495H76.6667C75.8931 63.0495 75.1513 62.7422 74.6043 62.1952C74.0573 61.6482 73.75 60.9064 73.75 60.1328V45.5495C73.75 44.7759 74.0573 44.0341 74.6043 43.4871C75.1513 42.9401 75.8931 42.6328 76.6667 42.6328Z",
    fill: "#6369D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M120.417 42.6328H76.6667C75.8931 42.6328 75.1513 42.9401 74.6043 43.4871C74.0573 44.0341 73.75 44.7759 73.75 45.5495V46.2786C73.75 45.5051 74.0573 44.7632 74.6043 44.2163C75.1513 43.6693 75.8931 43.362 76.6667 43.362H120.417C121.19 43.362 121.932 43.6693 122.479 44.2163C123.026 44.7632 123.333 45.5051 123.333 46.2786V45.5495C123.333 44.7759 123.026 44.0341 122.479 43.4871C121.932 42.9401 121.19 42.6328 120.417 42.6328Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M123.335 60.1328H73.7513C70.5342 60.1328 67.918 62.7491 67.918 65.9661V100.966C67.918 104.183 70.5342 106.799 73.7513 106.799H123.335C126.552 106.799 129.168 104.183 129.168 100.966V65.9661C129.168 62.7491 126.552 60.1328 123.335 60.1328Z",
    fill: "#1E54BF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M123.335 106.076H73.7513C70.5342 106.076 67.918 103.459 67.918 100.242V100.971C67.918 104.188 70.5342 106.805 73.7513 106.805H123.335C126.552 106.805 129.168 104.188 129.168 100.971V100.242C129.168 103.459 126.552 106.076 123.335 106.076Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M123.335 60.1328H73.7513C70.5342 60.1328 67.918 62.7491 67.918 65.9661V66.6953C67.918 63.4782 70.5342 60.862 73.7513 60.862H123.335C126.552 60.862 129.168 63.4782 129.168 66.6953V65.9661C129.168 62.7491 126.552 60.1328 123.335 60.1328Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M129.166 74.7188H117.843C113.614 74.7188 109.726 77.5713 108.918 81.7246C108.663 82.9958 108.692 84.3079 109.004 85.5664C109.317 86.8249 109.905 87.9984 110.726 89.0022C111.546 90.006 112.58 90.8152 113.751 91.3715C114.922 91.9277 116.203 92.2171 117.499 92.2188H129.166C129.939 92.2188 130.681 91.9115 131.228 91.3645C131.775 90.8175 132.083 90.0756 132.083 89.3021V77.6354C132.083 76.8619 131.775 76.12 131.228 75.573C130.681 75.026 129.939 74.7188 129.166 74.7188Z",
    fill: "#474FD5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M129.306 91.4896H117.455C115.554 91.4849 113.704 90.8761 112.171 89.751C110.639 88.6259 109.504 87.0429 108.93 85.2305C109.77 89.1855 113.299 92.2188 117.502 92.2188H129.168C129.851 92.2283 130.514 91.9933 131.039 91.5562C131.563 91.1192 131.913 90.5089 132.027 89.8359C131.56 90.8421 130.504 91.4896 129.306 91.4896Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M117.499 86.388C119.11 86.388 120.415 85.0822 120.415 83.4714C120.415 81.8605 119.11 80.5547 117.499 80.5547C115.888 80.5547 114.582 81.8605 114.582 83.4714C114.582 85.0822 115.888 86.388 117.499 86.388Z",
    fill: "#0A17F9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M117.499 86.388C119.11 86.388 120.415 85.0822 120.415 83.4714C120.415 81.8605 119.11 80.5547 117.499 80.5547C115.888 80.5547 114.582 81.8605 114.582 83.4714C114.582 85.0822 115.888 86.388 117.499 86.388Z",
    fill: "url(#paint0_linear_5764_10675)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M129.303 75.4479H117.452C115.556 75.4433 113.707 76.043 112.175 77.1601C110.642 78.2772 109.506 79.8536 108.93 81.6604C109.688 77.5683 113.725 74.7188 117.499 74.7188H129.166C130.609 74.7188 131.791 75.725 132.024 77.1017C131.557 76.0954 130.501 75.4479 129.303 75.4479Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M111.668 89.9766L127.085 105.397C128.351 104.321 129.168 102.746 129.168 100.967V92.2166H117.501C115.276 92.2166 113.214 91.3503 111.668 89.9766Z",
    fill: "url(#paint1_linear_5764_10675)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M73.75 48.4688H123.333V57.2188H73.75V48.4688Z",
    fill: "#303642"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M73.75 48.4688H123.333V52.8438H73.75V48.4688Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M129.168 74.7161V65.9661C129.168 62.7491 126.552 60.1328 123.335 60.1328V45.5495C123.335 44.7759 123.027 44.0341 122.48 43.4871C121.933 42.9401 121.192 42.6328 120.418 42.6328H76.668C75.8944 42.6328 75.1526 42.9401 74.6056 43.4871C74.0586 44.0341 73.7513 44.7759 73.7513 45.5495V60.1328C70.5342 60.1328 67.918 62.7491 67.918 65.9661V100.966C67.918 104.183 70.5342 106.799 73.7513 106.799H123.335C126.552 106.799 129.168 104.183 129.168 100.966V92.2162C129.942 92.2162 130.683 91.9089 131.23 91.3619C131.777 90.8149 132.085 90.073 132.085 89.2995V77.6328C132.085 76.8593 131.777 76.1174 131.23 75.5704C130.683 75.0234 129.942 74.7161 129.168 74.7161Z",
    fill: "url(#paint2_linear_5764_10675)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5764_10675",
    x1: 114.856,
    y1: 82.2376,
    x2: 120.141,
    y2: 84.7051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5764_10675",
    x1: 116.3,
    y1: 86.9782,
    x2: 128.518,
    y2: 99.1961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101828",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101828",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5764_10675",
    x1: 66.4421,
    y1: 60.5761,
    x2: 133.931,
    y2: 92.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStatewallet);
export default __webpack_public_path__ + "static/media/EmptyStatewallet.cbade385c171a41c04ae59d5bc6eb21d.svg";
export { ForwardRef as ReactComponent };